import { useContext } from 'react'
import { ELoaderContext } from '@/client/context/Loader'
import * as S from './styles'
import { Loader } from '../Loader'
import { Text } from '../Text'

export const SiteLoader = () => {
  const { elMessage, eload } = useContext(ELoaderContext)

  return (
    <S.Wrapper eLoad={eload}>
      <S.LoadSet>
        <Loader></Loader>
        <Text size='lg'>{elMessage}</Text>
      </S.LoadSet>
    </S.Wrapper>
  )
}
